let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kh20V")).then(() => parcelRequire('9rpMN'));